import React, { useRef, useEffect, useState } from 'react';
import { View, Platform } from 'react-native';
import styled, { css } from 'styled-components/native';

import usePrefersReducedMotion from 'app/src/hooks/usePrefersReducedMotion';
import { duration, easing } from 'app/src/styles/motion';

// Uses fadeReveal keyframes defined in index.css
const AnimatedContainer = styled(View)`
  ${props => props.shouldAnimate && Platform.OS === 'web' && css`
    animation: fadeReveal ${duration.normal}ms ${easing.reveal} both;
  `}
  ${props => !props.shouldAnimate && css`
    opacity: 1;
  `}
`;

/**
 * PageContent wraps page content with a fade-reveal animation on mount.
 * Respects user's reduced motion preference.
 *
 * On web: applies CSS keyframe animation
 * On native: passes through without animation (native animations handled separately)
 */
const PageContent = ({ children }) => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [hasAnimated, setHasAnimated] = useState(false);
  const containerRef = useRef(null);

  // Only animate once per mount, and skip if reduced motion is preferred
  const shouldAnimate = Platform.OS === 'web' && !prefersReducedMotion && !hasAnimated;

  useEffect(() => {
    if (shouldAnimate) {
      setHasAnimated(true);
    }
  }, [shouldAnimate]);

  return (
    <AnimatedContainer
      ref={containerRef}
      shouldAnimate={shouldAnimate}
    >
      {children}
    </AnimatedContainer>
  );
};

export default PageContent;
